/*
 * component-promo-code.js — Slice 27 Block 2 (_product-promo-code).
 *
 * Two tiny delegated behaviors, both keyed off attributes that carry the code itself:
 *   - [data-ppc-copy]  → copy-to-clipboard.
 *   - [data-ppc-apply] → silent apply: fetch('/discount/CODE') sets Shopify's discount
 *     cookie with no navigation, then '/cart/update.js' syncs the cart JSON so a mini-cart
 *     reflects it; the button flashes its "Applied" label. The code rides the cookie and
 *     shows on the cart once the visitor adds the product. (Optimistic — the theme can't
 *     verify the code; BOGO codes won't auto-add the free item via this URL.)
 *
 * One delegated document click listener per behavior (SRA-safe: survives the PDP variant
 * re-render and works on the modal's cloned button with no re-bind). Emitted only when a
 * copy OR apply button renders. addEventListener only; no window.theme pollution beyond the
 * single guard flag (J12).
 */
(function () {
  'use strict';
  if (window.__PPC__) return;
  window.__PPC__ = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ppc-copy]') : null;
    if (!btn || btn.dataset.copyBusy === '1') return;
    var code = btn.getAttribute('data-ppc-copy') || '';
    if (!code) return;
    copyText(code, btn);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-ppc-apply]') : null;
    if (!btn || btn.dataset.applyBusy === '1') return;
    var code = btn.dataset.ppcApply || '';
    if (!code) return;
    applyCode(code, btn);
  });

  function copyText(code, btn) {
    btn.dataset.copyBusy = '1';
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { flipTo(btn, btn.getAttribute('data-copied') || 'Copied'); }).catch(function () { legacyCopy(code, btn); });
    } else {
      legacyCopy(code, btn);
    }
  }

  function legacyCopy(code, btn) {
    try {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      flipTo(btn, btn.getAttribute('data-copied') || 'Copied');
    } catch (err) { delete btn.dataset.copyBusy; /* leave the code visible */ }
  }

  function applyCode(code, btn) {
    btn.dataset.applyBusy = '1';
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: {} })
        });
      })
      .then(function () { flipTo(btn, btn.getAttribute('data-ppc-applied') || 'Applied'); })
      .catch(function () { delete btn.dataset.applyBusy; });
  }

  // Swap the button text to a confirmation label, announce it, then revert. Used by both
  // copy (data-copied) and apply (data-ppc-applied). Each caller sets its own busy flag up
  // front; the revert clears both (deleting an absent one is harmless).
  function flipTo(btn, done) {
    var orig = btn.getAttribute('data-orig-label');
    if (orig === null) {
      orig = btn.textContent;
      btn.setAttribute('data-orig-label', orig);
    }
    btn.textContent = done;
    announce(btn, done);
    setTimeout(function () {
      btn.textContent = orig;
      delete btn.dataset.copyBusy;
      delete btn.dataset.applyBusy;
    }, 1600);
  }

  function announce(btn, msg) {
    var root = btn.closest ? btn.closest('.promo-code') : null;
    var live = root ? root.querySelector('.promo-code__sr-status') : null;
    if (live) live.textContent = msg;
  }
})();
